export default __webpack_public_path__ + "static/media/tiff.fef13003.svg";